module.exports = __webpack_public_path__ + "static/media/San Mateo Ave San Bruno, CA2.031f08fe.jpg";